import { Navbar } from '../bordeaux/components/Navbar';
import { Hero } from '../bordeaux/components/Hero';
import { Services } from '../bordeaux/components/Services';
import { BayWindows } from '../bordeaux/components/BayWindows';
import { WhatsAppDiagnostic } from '../bordeaux/components/WhatsAppDiagnostic';
import { Contact } from '../bordeaux/components/Contact';
import { Footer } from '../bordeaux/components/Footer';
import { useEffect } from 'react';

export default function SaintAndreCubzac() {
  useEffect(() => {
    document.title = "Réparation Fenêtres Saint-André-de-Cubzac | PVC Alu Bois | Baies Vitrées";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert en réparation de fenêtres à Saint-André-de-Cubzac ✓ PVC, Aluminium, Bois ✓ Baies vitrées toutes marques ✓ Intervention rapide ✓ Devis gratuit');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Saint-André-de-Cubzac, fenêtres PVC Saint-André, baies vitrées Saint-André-de-Cubzac, vitrier Saint-André-de-Cubzac');
    }

    const metaGeoPosition = document.querySelector('meta[name="geo.position"]');
    if (metaGeoPosition) {
      metaGeoPosition.setAttribute('content', '45.0000;-0.4500');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.position';
      meta.content = '45.0000;-0.4500';
      document.head.appendChild(meta);
    }

    const metaGeoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (metaGeoPlacename) {
      metaGeoPlacename.setAttribute('content', 'Saint-André-de-Cubzac, Gironde, France');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.placename';
      meta.content = 'Saint-André-de-Cubzac, Gironde, France';
      document.head.appendChild(meta);
    }

    const metaGeoRegion = document.querySelector('meta[name="geo.region"]');
    if (metaGeoRegion) {
      metaGeoRegion.setAttribute('content', 'FR-33');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'geo.region';
      meta.content = 'FR-33';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar city="Saint-André-de-Cubzac" />
      <Hero city="Saint-André-de-Cubzac" />
      <Services city="Saint-André-de-Cubzac" />
      <BayWindows city="Saint-André-de-Cubzac" />
      <WhatsAppDiagnostic city="Saint-André-de-Cubzac" />
      <Contact city="Saint-André-de-Cubzac" />
      <Footer city="Saint-André-de-Cubzac" />
    </div>
  );
}